enum FrequencyStatus {
  PAST_DUE = "Past due",
  UP_TO_DATE = "Up to date",
  UPCOMING = "Upcoming",
  UNKNOWN = "Unknown",
}

export default FrequencyStatus;
